import { isOutreachWireError } from '@discovr/types';
import { codeOf, statusOf } from './sendLabels';

const HTTP_FORBIDDEN = 403;
/** Go's code for a server whose outreach Postgres is not configured (every CRM route answers 503 with it). */
const OUTREACH_UNAVAILABLE_CODE = 'OUTREACH_UNAVAILABLE';

export const OUTREACH_NOT_SET_UP = 'Outreach isn’t set up on this server yet.';

/** The request id the server stamped on its error, so a reported failure can be found in its logs. */
function traceIdOf(error: unknown): string | undefined {
  const traceId = typeof error === 'object' && error !== null ? (error as { traceId?: unknown }).traceId : undefined;
  return typeof traceId === 'string' && traceId !== '' ? traceId : undefined;
}

function retryCopy(subject: string, error: unknown): string {
  const copy = `Couldn’t load ${subject}. Refresh to try again.`;
  const traceId = traceIdOf(error);
  if (!traceId) return copy;
  return `${copy} Reference: ${traceId}`;
}

/**
 * What a failed CRM read says, by who failed, so the page's own problems never read like the server's:
 * - the page could not read the server's answer (a contract break; refreshing will not fix it),
 * - the reader has no access to this campaign's outreach,
 * - the server has no outreach set up,
 * - the server or the network failed (worth a retry, with the request id to quote).
 */
export function crmLoadErrorCopy(subject: string, error: unknown): string {
  if (isOutreachWireError(error)) {
    return `Couldn’t show ${subject}: this page is out of date with the server. Reload the page, and tell the team if it keeps happening.`;
  }
  if (statusOf(error) === HTTP_FORBIDDEN) return `You don’t have access to ${subject} on this campaign.`;
  if (codeOf(error) === OUTREACH_UNAVAILABLE_CODE) return OUTREACH_NOT_SET_UP;
  return retryCopy(subject, error);
}
